<div #footerRef class="footer">
  <div class="footer-container">
    <div class="top scroll-fade">
      <div class="logo">
        <icon name="blauwtand"></icon>
        <!-- <div class="tagline">IT services & consulting</div> -->
        <!-- <div class="logo-gradient" aria-hidden="true"></div> -->
      </div>
      <div class="nav-links">
        <div class="eyebrow">Blauwtand</div>
        <div class="nav-link" (click)="navigateTo('vacatures')">IT vacatures</div>
        <div class="nav-link" (click)="navigateTo('opdrachtgevers')">IT oplossingen opdrachtgevers</div>
        <div class="nav-link" (click)="navigateTo('open-sollicitatie')">Open IT sollicitatie bij Blauwtand</div>
      </div>
      <div class="nav-links">
        <div class="eyebrow">Over ons</div>
        <div class="nav-link" (click)="navigateTo('over-blauwtand')">Over Blauwtand</div>
        <div class="nav-link" (click)="navigateTo('stories')">Blauwtand stories</div>
        <div class="nav-link" (click)="navigateTo('werken-bij')">Werken bij Blauwtand</div>
        <div class="nav-link" (click)="navigateToSitemap()">Sitemap</div>
      </div>
      <div class="contact">
        <div class="eyebrow">Contact</div>
        <div class="contact-child">
          <icon name="call_filled"></icon>
          <div (click)="phoneCall('31798080320')">{{ phoneNumber }}</div>
        </div>
        <div class="contact-child">
          <icon name="whatsapp"></icon>
          <div (click)="whatsapp('31798080328')">{{ whatsAppNumber }}</div>
        </div>
        <div class="contact-child">
          <icon name="email_filled"></icon>
          <div (click)="email('info@blauwtand.com')">
            info&#64;blauwtand.com
          </div>
        </div>
      </div>
      <div class="socials">
        <div class="eyebrow">Volg ons</div>
        <icon name="facebook" (click)="redirectTo('facebook')"></icon>
        <!-- <icon name="twitter"  (click)="redirectTo('twitter')"></icon> -->
        <icon name="linkedin" (click)="redirectTo('linkedin')"></icon>
        <icon
          name="instagram"
          class="insta"
          (click)="redirectTo('instagram')"
        ></icon>
      </div>
    </div>
    <div class="bottom scroll-fade">
      <div>COPYRIGHT © {{ currentYear }} — BLAUWTAND ALL RIGHTS RESERVED.</div>
      <div class="kvk">KvK nr. 84981741.</div>
      <div class="privacy-policy" (click)="navigateTo('privacy-statement')">
        Privacy statement.
      </div>
    </div>
  </div>
</div>
